"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
// TODO: use theme.
var buttonSizes = {
    auto: {
        fontSize: '15px',
        fontWeight: 400,
        height: '40px',
        padding: '0 8px',
        width: 'auto',
    },
    fullWidth: {
        fontSize: '16px',
        fontWeight: 900,
        height: '48px',
        padding: '0 8px',
        width: '100%',
    },
    large: {
        fontSize: '16px',
        fontWeight: 900,
        height: '48px',
        padding: '0 8px',
        width: '200px',
    },
    medium: {
        fontSize: '16px',
        fontWeight: 900,
        height: '48px',
        padding: '0 8px',
        width: '164px',
    },
    mini: {
        fontSize: '12px',
        fontWeight: 900,
        height: '32px',
        lineHeight: '32px',
        padding: '0 8px',
        width: '96px',
    },
    small: {
        fontSize: '14px',
        fontWeight: 900,
        height: '48px',
        padding: '0 8px',
        width: '120px',
    },
    super: {
        fontSize: '16px',
        fontWeight: 900,
        height: '48px',
        padding: '0 8px',
        width: '384px',
    },
    xLarge: {
        fontSize: '16px',
        fontWeight: 900,
        height: '48px',
        padding: '0 8px',
        width: '260px',
    },
    xxLarge: {
        fontSize: '16px',
        fontWeight: 900,
        height: '48px',
        padding: '0 8px',
        width: '343px',
    },
    xxxLarge: {
        fontSize: '16px',
        fontWeight: 900,
        height: '48px',
        padding: '0 8px',
        width: '360px',
    },
};
var setDisplay = function (size) {
    return size === 'fullWidth' ? 'block' : 'inline-block';
};
var setBackground = function (borderless, secondary, disabled, theme, backgroundColor) {
    if (backgroundColor && !disabled)
        return utils_1.parseThemePath(backgroundColor, theme, colors_1.colors.BLUE_300);
    if (borderless)
        return 'transparent';
    if (disabled && !secondary) {
        return utils_1.parseThemePath('axsui.components.buttons.primary.disabledBackground', theme, colors_1.colors.GREY_250);
    }
    if (disabled && secondary) {
        return 'transparent';
    }
    if (secondary) {
        return utils_1.parseThemePath('axsui.components.buttons.secondary.background', theme, colors_1.colors.WHITE);
    }
    return utils_1.parseThemePath('axsui.components.buttons.primary.background', theme, colors_1.colors.BLUE_300);
};
var setHoverBackground = function (borderless, disabled, theme, secondary, backgroundColorHover) {
    if (backgroundColorHover && !disabled) {
        return utils_1.parseThemePath(backgroundColorHover, theme, colors_1.colors.BLUE_300);
    }
    if (borderless)
        return 'transparent';
    if (disabled && secondary) {
        return 'transparent';
    }
    if (disabled && !secondary) {
        return utils_1.parseThemePath('axsui.components.buttons.primary.disabledBackgroundHover', theme, colors_1.colors.GREY_250);
    }
    if (!disabled && !secondary) {
        return utils_1.parseThemePath('axsui.components.buttons.primary.backgroundHover', theme, colors_1.colors.BLUE_400);
    }
    if (!disabled && secondary) {
        return utils_1.parseThemePath('axsui.components.buttons.secondary.backgroundHover', theme, colors_1.colors.BLUE_400);
    }
};
var setHoverBorder = function (disabled, secondary, theme, borderColorHover, borderless) {
    if (borderless) {
        return 'none';
    }
    if (borderColorHover && !disabled) {
        return "2px solid " + utils_1.parseThemePath(borderColorHover, theme, colors_1.colors.BLUE_300) + " !important";
    }
    if (!disabled && secondary) {
        return "2px solid " + utils_1.parseThemePath('axsui.components.buttons.secondary.borderColorHover', theme, colors_1.colors.BLUE_400);
    }
    if (!disabled && !secondary) {
        return "2px solid " + utils_1.parseThemePath('axsui.components.buttons.primary.borderColorHover', theme, colors_1.colors.BLUE_400);
    }
    if (disabled && secondary) {
        return "2px solid " + utils_1.parseThemePath('axsui.components.buttons.secondary.disabledBorderHover', theme, colors_1.colors.GREY_250) + " !important";
    }
};
var setForeGround = function (borderless, secondary, disabled, theme, color) {
    if (color && !disabled)
        return utils_1.parseThemePath(color, theme, colors_1.colors.BLUE_300);
    if (borderless) {
        return utils_1.parseThemePath('axsui.components.buttons.primary.background', theme, colors_1.colors.BLUE_300);
    }
    if (disabled && !secondary) {
        return utils_1.parseThemePath('axsui.components.buttons.primary.disabled', theme, colors_1.colors.WHITE);
    }
    if (disabled && secondary) {
        return utils_1.parseThemePath('axsui.components.buttons.secondary.disabled', theme, colors_1.colors.WHITE);
    }
    if (secondary) {
        return utils_1.parseThemePath('axsui.components.buttons.secondary.color', theme, colors_1.colors.BLUE_300);
    }
    if (!secondary) {
        return utils_1.parseThemePath('axsui.components.buttons.primary.color', theme, colors_1.colors.WHITE);
    }
};
var setBorder = function (borderless, secondary, disabled, theme, borderColor) {
    if (borderColor && !disabled) {
        return "2px solid " + utils_1.parseThemePath(borderColor, theme, colors_1.colors.BLUE_300);
    }
    if (borderless) {
        return 'none';
    }
    if (secondary && !disabled) {
        return "2px solid " + utils_1.parseThemePath('axsui.components.buttons.secondary.borderColor', theme, colors_1.colors.BLUE_300);
    }
    if (secondary && disabled) {
        return "2px solid " + utils_1.parseThemePath('axsui.components.buttons.secondary.disabledBorder', theme, colors_1.colors.GREY_250);
    }
    if (!secondary && !disabled) {
        return "2px solid " + utils_1.parseThemePath('axsui.components.buttons.primary.borderColor', theme, colors_1.colors.BLUE_300);
    }
    if (!secondary && disabled) {
        return "2px solid " + utils_1.parseThemePath('axsui.components.buttons.primary.disabledBorder', theme, colors_1.colors.GREY_250);
    }
    return 'none';
};
var setHoverForeground = function (secondary, disabled, theme, borderless, colorHover) {
    if (colorHover && !disabled)
        return utils_1.parseThemePath(colorHover, theme, colors_1.colors.BLUE_300);
    if (borderless) {
        return utils_1.parseThemePath('axsui.components.buttons.primary.backgroundHover', theme, colors_1.colors.BLUE_400);
    }
    if (secondary && !disabled) {
        return utils_1.parseThemePath('axsui.components.buttons.secondary.colorHover', theme, colors_1.colors.WHITE);
    }
    if (secondary && disabled) {
        return utils_1.parseThemePath('axsui.components.buttons.secondary.disabledHover', theme, colors_1.colors.WHITE);
    }
    if (!secondary && disabled) {
        return utils_1.parseThemePath('axsui.components.buttons.primary.disabledHover', theme, colors_1.colors.WHITE);
    }
    return utils_1.parseThemePath('axsui.components.buttons.primary.colorHover', theme, colors_1.colors.WHITE);
};
var defaultStyles = function () {
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    border: ", ";\n    border-radius: ", ";\n    color: ", ";\n    cursor: ", ";\n    display: ", ";\n    float: ", ";\n    font-size: ", ";\n    font-weight: ", ";;\n    font-family: ", ";\n    height: ", ";\n    margin: 0 16px 0 0;\n    min-width: ", ";\n    outline: none;\n    padding: ", ";\n    text-transform: ", ";\n    transition: all .1s ease;\n    vertical-align: ", ";\n    width: ", ";\n    -webkit-font-smoothing: antialiased;\n\n    @media (max-width: ", ") {\n      width: ", ";\n    }\n\n    &:last-of-type {\n      margin-right: 0;\n    }\n\n     &:hover {\n      background: ", ";\n      border: ", ";\n      color: ", ";\n       };\n  }"], ["\n    background-color: ",
        ";\n    border: ",
        ";\n    border-radius: ", ";\n    color: ",
        ";\n    cursor: ", ";\n    display: ", ";\n    float: ", ";\n    font-size: ", ";\n    font-weight: ", ";;\n    font-family: ",
        ";\n    height: ", ";\n    margin: 0 16px 0 0;\n    min-width: ", ";\n    outline: none;\n    padding: ",
        ";\n    text-transform: ",
        ";\n    transition: all .1s ease;\n    vertical-align: ", ";\n    width: ",
        ";\n    -webkit-font-smoothing: antialiased;\n\n    @media (max-width: ",
        ") {\n      width: ",
        ";\n    }\n\n    &:last-of-type {\n      margin-right: 0;\n    }\n\n     &:hover {\n      background: ",
        ";\n      border: ",
        ";\n      color: ",
        ";\n       };\n  }"])), function (_a) {
        var borderless = _a.borderless, secondary = _a.secondary, disabled = _a.disabled, theme = _a.theme, backgroundColor = _a.backgroundColor;
        return setBackground(borderless, secondary, disabled, theme, backgroundColor);
    }, function (_a) {
        var borderless = _a.borderless, secondary = _a.secondary, disabled = _a.disabled, theme = _a.theme, borderColor = _a.borderColor;
        return setBorder(borderless, secondary, disabled, theme, borderColor);
    }, function (_a) {
        var borderRadius = _a.borderRadius, theme = _a.theme;
        return borderRadius ? borderRadius : theme.axsui.buttons.primary.borderRadius;
    }, function (_a) {
        var borderless = _a.borderless, secondary = _a.secondary, disabled = _a.disabled, theme = _a.theme, color = _a.color;
        return setForeGround(borderless, secondary, disabled, theme, color);
    }, function (_a) {
        var disabled = _a.disabled;
        return (disabled ? 'default' : 'pointer');
    }, setDisplay, function (_a) {
        var float = _a.float;
        return (float ? float : 'none');
    }, function (_a) {
        var size = _a.size;
        return buttonSizes[size].fontSize;
    }, function (_a) {
        var fontWeight = _a.fontWeight;
        return (fontWeight ? fontWeight : '900');
    }, function (_a) {
        var fontFamily = _a.fontFamily;
        return fontFamily ? fontFamily : 'Lato, sans-serif';
    }, function (_a) {
        var borderless = _a.borderless, size = _a.size;
        return borderless ? 'auto' : size === 'auto' ? '48px' : buttonSizes[size].height;
    }, function (_a) {
        var borderless = _a.borderless;
        return (borderless ? 0 : '90px');
    }, function (_a) {
        var size = _a.size, borderless = _a.borderless;
        return borderless ? 0 : buttonSizes[size].padding;
    }, function (_a) {
        var borderless = _a.borderless, variation = _a.variation;
        return borderless || variation === 'dropButton' ? 'capitalize' : 'uppercase';
    }, function (_a) {
        var borderless = _a.borderless;
        return borderless ? '0' : 'middle';
    }, function (_a) {
        var size = _a.size, borderless = _a.borderless;
        return borderless || size === 'auto' ? 'auto' : buttonSizes[size].width;
    }, function (_a) {
        var theme = _a.theme;
        return theme.sizes ? theme.sizes.phone : 'large';
    }, function (_a) {
        var size = _a.size;
        return size === 'large' || size === 'xLarge' ? '100%' : 'large';
    }, function (_a) {
        var borderless = _a.borderless, disabled = _a.disabled, theme = _a.theme, secondary = _a.secondary, backgroundHover = _a.backgroundHover;
        return setHoverBackground(borderless, disabled, theme, secondary, backgroundHover);
    }, function (_a) {
        var disabled = _a.disabled, secondary = _a.secondary, theme = _a.theme, borderColorHover = _a.borderColorHover, borderless = _a.borderless;
        return setHoverBorder(disabled, secondary, theme, borderColorHover, borderless);
    }, function (_a) {
        var secondary = _a.secondary, disabled = _a.disabled, theme = _a.theme, borderless = _a.borderless, colorHover = _a.colorHover;
        return setHoverForeground(secondary, disabled, theme, borderless, colorHover);
    });
};
var AXSButton = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), defaultStyles);
var defaultProps = {
    borderRadius: '2px',
};
var SimpleButton = function (_a) {
    var fontSize = _a.fontSize, fontWeight = _a.fontWeight, fontFamily = _a.fontFamily, children = _a.children, className = _a.className, props = __rest(_a, ["fontSize", "fontWeight", "fontFamily", "children", "className"]);
    return (React.createElement(AXSButton, __assign({ fontSize: fontSize, fontWeight: fontWeight, fontFamily: fontFamily, role: "button" }, props, { className: classnames_1.default(['c-axs-button', className]) }), children));
};
SimpleButton.defaultProps = defaultProps;
exports.default = SimpleButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=SimpleButton.js.map